import {useQueryClient} from '@tanstack/react-query';
import {createApiQuery, createBatchedApiQuery, useApiMutation} from './api';
import {
  SaveTag,
  DeleteTag,
  GetTags,
  GetTagDetails,
} from '../../shared/api/definitions/tags';
import {GetDynamicListMembership} from '../../shared/api/definitions/scoredAccounts';
import {ObjectId} from 'bson';

export const TagQueryKeys = {
  all: ['tags'] as const,
  list: () => [...TagQueryKeys.all, 'list'],
  details: () => [...TagQueryKeys.all, 'details'],
  detailsById: (tagId: ObjectId) => [
    ...TagQueryKeys.details(),
    tagId.toString(),
  ],
  dynamicMembership: ({accountId}: {accountId: ObjectId}) =>
    [...TagQueryKeys.all, 'dynamicMembership', accountId.toString()] as const,
};

export const useTags = createApiQuery(GetTags, (params) => [
  ...TagQueryKeys.list(),
  params,
]);

export const useGetTagDetails = createApiQuery(GetTagDetails, (params) => [
  ...TagQueryKeys.details(),
  params.tagId.toString(),
]);

export const useSaveTagMutation = () => {
  const queryClient = useQueryClient();
  return useApiMutation(SaveTag, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: TagQueryKeys.all,
      });
    },
  });
};

export const useDynamicListMembership = createBatchedApiQuery(
  GetDynamicListMembership,
  TagQueryKeys.dynamicMembership,
  {
    staleTime: 60_000,
  }
);

export const useDeleteTagMutation = () => {
  const queryClient = useQueryClient();
  return useApiMutation(DeleteTag, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: TagQueryKeys.all,
      });
    },
  });
};
